// import React, { useState, useEffect } from "react";
// import Minicart from "../Pages/Minicart";
// import { Link, useLocation } from "react-router-dom";
// import { fetchcategorylist, fetchcart } from "../Pages/Apiservice";
// import SearchModal from "../Pages/SearchModal";
// import Loading from "../Pages/Loading";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// function Header() {
//   const location = useLocation();
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [cartItems, setCartItems] = useState([]);
//   const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
//   const [pageloading, setPageloading] = useState(true);
//   const [cartItemCount, setCartItemCount] = useState(0);
//   const navigate = useNavigate();

//   // Helper function to check if a path is active
//   const isActive = (path) => {
//     return location.pathname === path ? "active" : "";
//   };

//   const fetchCartCount = async () => {
//     try {
//       const userId = localStorage.getItem("userId");
//       let url = "https://vishushethra.com/api/api/cart/session-count/";

//       // Create axios instance with default config
//       const apiClient = axios.create({
//         baseURL: "https://ecom.vishushethra.com/api",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         withCredentials: false,
//       });

//       // Add request interceptor to handle CORS
//       apiClient.interceptors.request.use(
//         (config) => {
//           return config;
//         },
//         (error) => {
//           return Promise.reject(error);
//         },
//       );

//       // Add response interceptor to handle errors
//       apiClient.interceptors.response.use(
//         (response) => {
//           return response;
//         },
//         (error) => {
//           if (error.response) {
//             console.error(
//               "Response error:",
//               error.response.status,
//               error.response.data,
//             );
//           } else if (error.request) {
//             console.error("No response received:", error.request);
//           } else {
//             console.error("Request setup error:", error.message);
//           }
//           return Promise.reject(error);
//         },
//       );

//       if (userId) {
//         url = `/api/cart/count-by-user/${userId}/`;
//       } else {
//         url = `/api/cart/session-count/`;
//       }

//       const response = await apiClient.get(url);

//       if (response.data && response.data.cart_count !== undefined) {
//         setCartItemCount(response.data.cart_count);
//       }
//     } catch (error) {
//       console.error("Error fetching cart count:", error);
//       // Only log the error, don't set count to 0 to avoid UI flickering
//       // The interval will try again
//     }
//   };

//   useEffect(() => {
//     const getCategories = async () => {
//       try {
//         const data = await fetchcategorylist();
//         setCategories(data);
//         setLoading(false);
//       } catch (error) {
//         setError("Failed to load categories.");
//         setLoading(false);
//       } finally {
//         setPageloading(false);
//       }
//     };
//     getCategories();

//     // Fetch initial cart count
//     fetchCartCount();

//     // Set up interval to periodically check cart count
//     const cartCountInterval = setInterval(fetchCartCount, 10000); // Reduced to 10 seconds

//     return () => clearInterval(cartCountInterval);
//   }, []);

//   useEffect(() => {
//     const getCartItems = async () => {
//       try {
//         const userId = localStorage.getItem("userId");
//         if (userId) {
//           const data = await fetchcart(userId);
//           setCartItems(data.items || []);
//         } else {
//           console.error("No userid found in localStorage");
//         }
//       } catch (error) {
//         console.error("Failed to fetch cart items", error);
//       }
//     };
//     getCartItems();
//   }, []);

//   const toggleCart = () => {
//     const isMobile = window.innerWidth < 768;

//     if (isMobile) {
//       navigate("/Cart");
//     } else {
//       // Refresh cart count when opening the cart
//       fetchCartCount();
//       // setIsCartOpen((prevState) => !prevState);
//       navigate("/Cart");
//     }
//   };

//   const closeCart = () => {
//     setIsCartOpen(false);
//   };

//   const [isScrolled, setScrolled] = useState(false);

//   const handleScroll = () => {
//     setScrolled(window.scrollY > 50);
//   };

//   useEffect(() => {
//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const [isNavOpen, setIsNavOpen] = useState(false);

//   const toggleNav = () => {
//     setIsNavOpen(!isNavOpen);
//   };

//   const closeNav = () => {
//     setIsNavOpen(false);
//   };

//   const toggleDropdown = () => {
//     setIsDropdownOpen((prevState) => !prevState);
//   };

//   const toggleSearchModal = () => {
//     setIsSearchModalOpen((prevState) => !prevState);
//   };

//   if (pageloading) {
//     return <Loading />;
//   }

//   const username = localStorage.getItem("username");
//   return (
//     <header className={`header_section ${isScrolled ? "header_scrolled" : ""}`}>
//       <div className="header_overlay">
//         <div className="header_content">
//           <div className="header_top">
//             <div className="container-fluid">
//               <div className="row">
//                 <div className="col-12">
//                   <div className="header_top_inner d-flex justify-content-between align-items-center">
//                     <div className="header_contact_info">
//                       <ul className="d-flex">
//                         <li className="text-white">
//                           <i className="icons icon-phone"></i>
//                           <Link to="tel:+919841211577">+91 98412 11577</Link>
//                         </li>
//                         <li className="text-white">
//                           <i className="icon-envelope-letter icons"></i>
//                           <Link to="mailto:vishushethra@gmail.com">
//                             vishushethra@gmail.com
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>

//                     <div className="header_top_sidebar d-flex align-items-center">
//                       <div className="header_social d-flex">
//                         <span>Follow us</span>
//                         <ul className="d-flex">
//                           <li>
//                             <Link
//                               to="https://wa.me/919841211577
// "
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               <i className="ion-social-whatsapp"></i>
//                             </Link>
//                           </li>
//                           <li>
//                             <Link to="#">
//                               <i className="icon-social-twitter icons"></i>
//                             </Link>
//                           </li>
//                           <li>
//                             <Link to="#">
//                               <i className="icon-social-facebook icons"></i>
//                             </Link>
//                           </li>
//                           <li>
//                             <Link to="#">
//                               <i className="icon-social-instagram icons"></i>
//                             </Link>
//                           </li>
//                           <li>
//                             <Link to="#">
//                               <i className="icon-social-youtube icons"></i>
//                             </Link>
//                           </li>
//                           <li>
//                             <Link to="#">
//                               <i className="icon-social-pinterest icons"></i>
//                             </Link>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="main_header">
//             <div className="container-fluid">
//               <div className="row">
//                 <div className="col-12">
//                   <div className="header_container d-flex justify-content-between align-items-center">
//                     <div className="canvas_open" onClick={toggleNav}>
//                       <Link to="javascript:void(0)">
//                         <i className="ion-navicon"></i>
//                       </Link>
//                     </div>
//                     <div className="header_logo">
//                       <Link className="sticky_none" to="/">
//                         <img
//                           src="./assets/img/logo/logo-1.png"
//                           alt=""
//                           style={{ height: "50px" }}
//                         />
//                       </Link>
//                     </div>

//                     <div className="main_menu d-none d-lg-block">
//                       <nav>
//                         <ul className="d-flex align-items-center justify-content-center">
//                           <li>
//                             <Link className={isActive("/")} to="/">
//                               Home
//                             </Link>
//                           </li>
//                           <li>
//                             <Link className={isActive("/About")} to="/About">
//                               About
//                             </Link>
//                           </li>
                          

//                           <li className="nav-item">
//                             <Link to="#" className="nav-link">
//                               Product
//                             </Link>
//                             <ul className="dropdown_Product pl-0 px-2">
//                               {categories.map((category) => (
//                                 <li
//                                   key={category.id}
//                                   style={{ width: "150px" }}
//                                 >
//                                   <Link to={`/product/${category.id}`}>
//                                     {category.name}
//                                   </Link>
//                                 </li>
//                               ))}
//                             </ul>
//                           </li>

//                           <li>
//                             <Link
//                               className={isActive("/Cart")}
//                               to="/Cart"
//                               onClick={() => {
//                                 window.location.href = "/Cart";
//                               }}
//                             >
//                               Cart
//                             </Link>
//                           </li>

//                           <li>
//                             <Link
//                               className={isActive("/Contact")}
//                               to="/Contact"
//                             >
//                               Contact
//                             </Link>
//                           </li>

//                           <li className="nav-item">
//                             <Link className={isActive("/Blog")} to="/Blog">
//                               Blog
//                             </Link>
//                           </li>

//                           <li>
//                             {username ? (
//                               <div className="header_login">
//                                 <Link
//                                   className={isActive("/AuthForm")}
//                                   to="/AuthForm"
//                                 >
//                                   <span>Hi, {username}</span>
//                                 </Link>
//                               </div>
//                             ) : (
//                               <Link
//                                 className={isActive("/AuthForm")}
//                                 to="/AuthForm"
//                               >
//                                 Signup/Login
//                               </Link>
//                             )}
//                           </li>
//                         </ul>
//                       </nav>
//                     </div>
//                     <div className="header_account">
//                       <ul className="d-flex">
//                         <li
//                           className="header_search"
//                           onClick={toggleSearchModal}
//                         >
//                           <Link to="#" style={{ color: "black" }}>
//                             <i className="icon-magnifier icons"></i>
//                           </Link>
//                         </li>

//                         <li>
//                           <Link to="/Favourite" style={{ color: "black" }}>
//                             <i className="icon-heart icons"></i>
//                           </Link>
//                         </li>
//                         <li
//                           className="shopping_cart"
//                           onClick={toggleCart}
//                           style={{ color: "black", cursor: "pointer" }}
//                         >
//                           <Link to="#" style={{ color: "black" }}>
//                             <i className="icon-basket-loaded icons"></i>
//                           </Link>
//                           <span className="item_count">{cartItemCount}</span>
//                         </li>
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className={`mobile_nav ${isNavOpen ? "open" : ""}`}>
//         <i
//           className="ion-android-close"
//           onClick={closeNav}
//           style={{ color: "black", fontSize: "30px", marginLeft: "30px" }}
//         ></i>
//         <ul>
//           <li>
//             <Link className={isActive("/")} to="/" onClick={closeNav}>
//               Home
//             </Link>
//           </li>
//           <li>
//             <Link className={isActive("/About")} onClick={closeNav} to="/About">
//               About
//             </Link>
//           </li>
//           <li className="productheaderalign-mobile">
//             <Link to="#" onClick={toggleDropdown}>
//               Product
//               <i className="arrow-down" style={{ marginLeft: "5px" }}></i>
//             </Link>
//             {isDropdownOpen && (
//               <ul className="dropdown_Product">
//                 {categories.map((category) => (
//                   <li key={category.id}>
//                     <Link to={`/product/${category.id}`} onClick={closeNav}>
//                       {category.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           <li>
//             <Link className={isActive("/Blog")} to="/Blog" onClick={closeNav}>
//               Blog
//             </Link>
//           </li>
//           <li>
//             <Link
//               className={isActive("/Contact")}
//               to="/Contact"
//               onClick={closeNav}
//             >
//               Contact
//             </Link>
//           </li>

//           <li>
//             {username ? (
//               <div>
//                 <Link
//                   className={isActive("/AuthForm")}
//                   to="/AuthForm"
//                   onClick={closeNav}
//                 >
//                   <span style={{ color: "black" }}>Hi, {username}</span>
//                 </Link>
//               </div>
//             ) : (
//               <Link
//                 className={isActive("/AuthForm")}
//                 to="/AuthForm"
//                 onClick={closeNav}
//               >
//                 Signup/Login
//               </Link>
//             )}
//           </li>
//         </ul>
//       </div>
//       <Minicart
//         isOpen={isCartOpen}
//         onClose={closeCart}
//         onCartUpdate={fetchCartCount}
//         cartItems={cartItems}
//       />
//       <SearchModal isOpen={isSearchModalOpen} onClose={toggleSearchModal} />
//     </header>
//   );
// }

// export default Header;






import React, { useState, useEffect } from "react";
import Minicart from "../Pages/Minicart";
import { Link, useLocation } from "react-router-dom";
import { fetchcategorylist, fetchcart } from "../Pages/Apiservice";
import SearchModal from "../Pages/SearchModal";
import Loading from "../Pages/Loading";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Header() {
  const location = useLocation();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [pageloading, setPageloading] = useState(true);
  const [cartItemCount, setCartItemCount] = useState(0);
  const navigate = useNavigate();

  // Helper function to check if a path is active
  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  const fetchCartCount = async () => {
    try {
      const userId = localStorage.getItem("userId");
      let url = "https://vishushethra.com/api/api/cart/session-count/";

      // Create axios instance with default config
      const apiClient = axios.create({
        baseURL: "https://vishushethra.com/api",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        withCredentials: false,
      });

      // Add request interceptor to handle CORS
      apiClient.interceptors.request.use(
        (config) => {
          return config;
        },
        (error) => {
          return Promise.reject(error);
        },
      );

      // Add response interceptor to handle errors
      apiClient.interceptors.response.use(
        (response) => {
          return response;
        },
        (error) => {
          if (error.response) {
            console.error(
              "Response error:",
              error.response.status,
              error.response.data,
            );
          } else if (error.request) {
            console.error("No response received:", error.request);
          } else {
            console.error("Request setup error:", error.message);
          }
          return Promise.reject(error);
        },
      );

      if (userId) {
        url = `/api/cart/count-by-user/${userId}/`;
      } else {
        url = `/api/cart/session-count/`;
      }

      const response = await apiClient.get(url);

      if (response.data && response.data.cart_count !== undefined) {
        setCartItemCount(response.data.cart_count);
      }
    } catch (error) {
      console.error("Error fetching cart count:", error);
      // Only log the error, don't set count to 0 to avoid UI flickering
      // The interval will try again
    }
  };

  useEffect(() => {
    const getCategories = async () => {
      try {
        const data = await fetchcategorylist();
        setCategories(data);
        setLoading(false);
      } catch (error) {
        setError("Failed to load categories.");
        setLoading(false);
      } finally {
        setPageloading(false);
      }
    };
    getCategories();

    // Fetch initial cart count
    fetchCartCount();

    // Set up interval to periodically check cart count
    const cartCountInterval = setInterval(fetchCartCount, 10000); // Reduced to 10 seconds

    return () => clearInterval(cartCountInterval);
  }, []);

  useEffect(() => {
    const getCartItems = async () => {
      try {
        const userId = localStorage.getItem("userId");
        if (userId) {
          const data = await fetchcart(userId);
          setCartItems(data.items || []);
        } else {
          console.error("No userid found in localStorage");
        }
      } catch (error) {
        console.error("Failed to fetch cart items", error);
      }
    };
    getCartItems();
  }, []);

  const toggleCart = () => {
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      navigate("/Cart");
    } else {
      // Refresh cart count when opening the cart
      fetchCartCount();
      // setIsCartOpen((prevState) => !prevState);
      navigate("/Cart");
    }
  };

  const closeCart = () => {
    setIsCartOpen(false);
  };

  const [isScrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    setScrolled(window.scrollY > 50);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const toggleAboutDropdown = () => {
    setIsAboutDropdownOpen((prevState) => !prevState);
  };

  const toggleSearchModal = () => {
    setIsSearchModalOpen((prevState) => !prevState);
  };

  if (pageloading) {
    return <Loading />;
  }

  const username = localStorage.getItem("username");
  return (
    <header className={`header_section ${isScrolled ? "header_scrolled" : ""}`}>
      <div className="header_overlay">
        <div className="header_content">
          <div className="header_top">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="header_top_inner d-flex justify-content-between align-items-center">
                    <div className="header_contact_info">
                      <ul className="d-flex">
                        <li className="text-white">
                          <i className="icons icon-phone"></i>
                          <Link to="tel:+919841211577">+91 98412 11577</Link>
                        </li>
                        <li className="text-white">
                          <i className="icon-envelope-letter icons"></i>
                          <Link to="mailto:vishushethra@gmail.com">
                            vishushethra@gmail.com
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <div className="header_top_sidebar d-flex align-items-center">
                      <div className="header_social d-flex">
                        <span>Follow us</span>
                        <ul className="d-flex">
                          <li>
                            <Link
                              to="https://wa.me/919841211577
"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="ion-social-whatsapp"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i className="icon-social-twitter icons"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i className="icon-social-facebook icons"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i className="icon-social-instagram icons"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i className="icon-social-youtube icons"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i className="icon-social-pinterest icons"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="main_header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="header_container d-flex justify-content-between align-items-center">
                    <div className="canvas_open" onClick={toggleNav}>
                      <Link to="javascript:void(0)">
                        <i className="ion-navicon"></i>
                      </Link>
                    </div>
                    <div className="header_logo">
                      <Link className="sticky_none" to="/">
                        <img
                          src="./assets/img/logo/logo-1.png"
                          alt=""
                          style={{ height: "50px" }}
                        />
                      </Link>
                    </div>

                    <div className="main_menu d-none d-lg-block">
                      <nav>
                        <ul className="d-flex align-items-center justify-content-center">
                          <li>
                            <Link className={isActive("/")} to="/">
                              Home
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className={isActive("/About")} to="/About">
                              About
                            </Link>
                            <ul className="dropdown_Product pl-0 px-2">
                              <li style={{ width: "150px" }}>
                                <Link
                                  className={isActive("/iron-and-steel")}
                                  to="/iron-and-steel"
                                >
                                  Iron &amp; Steel
                                </Link>
                              </li>
                              <li style={{ width: "150px" }}>
                                <Link
                                  className={isActive("/SS_Fabrication")}
                                  to="/SS_Fabrication"
                                >
                                  SS_Fabrication
                                </Link>
                              </li>
                              <li style={{ width: "150px" }}>
                                <Link
                                  className={isActive("/SS_Plates")}
                                  to="/SS_Plates"
                                >
                                  SS_Plates
                                </Link>
                              </li>
                            </ul>
                          </li>

                          <li className="nav-item">
                            <Link to="#" className="nav-link">
                              Product
                            </Link>
                            <ul className="dropdown_Product pl-0 px-2">
                              {categories.map((category) => (
                                <li
                                  key={category.id}
                                  style={{ width: "150px" }}
                                >
                                  <Link to={`/product/${category.id}`}>
                                    {category.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>

                          <li>
                            <Link
                              className={isActive("/Cart")}
                              to="/Cart"
                              onClick={() => {
                                window.location.href = "/Cart";
                              }}
                            >
                              Cart
                            </Link>
                          </li>

                          <li>
                            <Link
                              className={isActive("/Contact")}
                              to="/Contact"
                            >
                              Contact
                            </Link>
                          </li>

                          <li className="nav-item">
                            <Link className={isActive("/Blog")} to="/Blog">
                              Blog
                            </Link>
                          </li>

                          <li>
                            {username ? (
                              <div className="header_login">
                                <Link
                                  className={isActive("/AuthForm")}
                                  to="/AuthForm"
                                >
                                  <span>Hi, {username}</span>
                                </Link>
                              </div>
                            ) : (
                              <Link
                                className={isActive("/AuthForm")}
                                to="/AuthForm"
                              >
                                Signup/Login
                              </Link>
                            )}
                          </li>
                        </ul>
                      </nav>
                    </div>
                    <div className="header_account">
                      <ul className="d-flex">
                        <li
                          className="header_search"
                          onClick={toggleSearchModal}
                        >
                          <Link to="#" style={{ color: "black" }}>
                            <i className="icon-magnifier icons"></i>
                          </Link>
                        </li>

                        <li>
                          <Link to="/Favourite" style={{ color: "black" }}>
                            <i className="icon-heart icons"></i>
                          </Link>
                        </li>
                        <li
                          className="shopping_cart"
                          onClick={toggleCart}
                          style={{ color: "black", cursor: "pointer" }}
                        >
                          <Link to="#" style={{ color: "black" }}>
                            <i className="icon-basket-loaded icons"></i>
                          </Link>
                          <span className="item_count">{cartItemCount}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`mobile_nav ${isNavOpen ? "open" : ""}`}>
        <i
          className="ion-android-close"
          onClick={closeNav}
          style={{ color: "black", fontSize: "30px", marginLeft: "30px" }}
        ></i>
        <ul>
          <li>
            <Link className={isActive("/")} to="/" onClick={closeNav}>
              Home
            </Link>
          </li>
          <li className="productheaderalign-mobile">
            <Link to="#" onClick={toggleAboutDropdown}>
              About
              <i className="arrow-down" style={{ marginLeft: "5px" }}></i>
            </Link>
            {isAboutDropdownOpen && (
              <ul className="dropdown_Product">
                <li>
                  <Link to="/About" onClick={closeNav}>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/iron-and-steel" onClick={closeNav}>
                    Iron &amp; Steel
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li className="productheaderalign-mobile">
            <Link to="#" onClick={toggleDropdown}>
              Product
              <i className="arrow-down" style={{ marginLeft: "5px" }}></i>
            </Link>
            {isDropdownOpen && (
              <ul className="dropdown_Product">
                {categories.map((category) => (
                  <li key={category.id}>
                    <Link to={`/product/${category.id}`} onClick={closeNav}>
                      {category.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>

          <li>
            <Link className={isActive("/Blog")} to="/Blog" onClick={closeNav}>
              Blog
            </Link>
          </li>
          <li>
            <Link
              className={isActive("/Contact")}
              to="/Contact"
              onClick={closeNav}
            >
              Contact
            </Link>
          </li>

          <li>
            {username ? (
              <div>
                <Link
                  className={isActive("/AuthForm")}
                  to="/AuthForm"
                  onClick={closeNav}
                >
                  <span style={{ color: "black" }}>Hi, {username}</span>
                </Link>
              </div>
            ) : (
              <Link
                className={isActive("/AuthForm")}
                to="/AuthForm"
                onClick={closeNav}
              >
                Signup/Login
              </Link>
            )}
          </li>
        </ul>
      </div>
      <Minicart
        isOpen={isCartOpen}
        onClose={closeCart}
        onCartUpdate={fetchCartCount}
        cartItems={cartItems}
      />
      <SearchModal isOpen={isSearchModalOpen} onClose={toggleSearchModal} />
    </header>
  );
}

export default Header;